import { PlatformEventType } from '../Platform.js';
export function getEventTypes({ platform, organization }) {
    if (STAMHOOFD.userMode === 'platform') {
        return platform.config.eventTypes;
    }
    if (organization) {
        return organization.meta.eventTypes.map((type) => {
            return PlatformEventType.create({
                ...type,
            });
        });
    }
    return [];
}
//# sourceMappingURL=getEventTypes.js.map